// filepath: src/pages/matrimony/components/sectionForms/LifestyleEditForm.tsx
import React from "react";
import {
  FormControl,
  FormLabel,
  Input,
  Select,
} from "@chakra-ui/react";
import { commonInputProps, commonSelectProps } from "src/pages/matrimony/pages/matrimonyForm.ui";
import { FIELD_LABELS } from "src/utils/matrimonyFieldLabels";
import {
  BODY_TYPE_OPTIONS,
  DIETARY_HABITS_OPTIONS,
  DRINKING_HABIT_OPTIONS,
  OWNS_HOUSE_OPTIONS,
  SKIN_TONE_OPTIONS,
  SMOKING_HABIT_OPTIONS,
} from "src/utils/matrimonyOptions";
import type { LifestyleState } from "src/types/marriageProfileSectionEdit.types";
import type { BaseSectionFormProps } from "./sectionFormProps";

type Props = BaseSectionFormProps & { values: LifestyleState };

const LifestyleEditForm: React.FC<Props> = ({ values, errors: _errors, setField }) => (
  <>
    <FormControl>
      <FormLabel>{FIELD_LABELS.HEIGHT_CM}</FormLabel>
      <Input
        {...commonInputProps}
        value={values.heightCm || ""}
        onChange={(e) => setField("heightCm", e.target.value)}
        placeholder="e.g. 160"
      />
    </FormControl>

    <FormControl>
      <FormLabel>{FIELD_LABELS.BODY_TYPE}</FormLabel>
      <Select
        {...commonSelectProps}
        value={values.bodyType || ""}
        onChange={(e) => setField("bodyType", e.target.value)}
        placeholder="Select body type"
      >
        {BODY_TYPE_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </Select>
    </FormControl>

    <FormControl>
      <FormLabel>{FIELD_LABELS.SKIN_TONE}</FormLabel>
      <Select
        {...commonSelectProps}
        value={values.skinTone || ""}
        onChange={(e) => setField("skinTone", e.target.value)}
        placeholder="Select skin tone"
      >
        {SKIN_TONE_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </Select>
    </FormControl>

    <FormControl>
      <FormLabel>{FIELD_LABELS.SMOKING_HABIT}</FormLabel>
      <Select
        {...commonSelectProps}
        value={values.smokingHabit || ""}
        onChange={(e) => setField("smokingHabit", e.target.value)}
        placeholder="Select"
      >
        {SMOKING_HABIT_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </Select>
    </FormControl>

    <FormControl>
      <FormLabel>{FIELD_LABELS.DRINKING_HABIT}</FormLabel>
      <Select
        {...commonSelectProps}
        value={values.drinkingHabit || ""}
        onChange={(e) => setField("drinkingHabit", e.target.value)}
        placeholder="Select"
      >
        {DRINKING_HABIT_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </Select>
    </FormControl>

    <FormControl>
      <FormLabel>{FIELD_LABELS.DIETARY_HABITS}</FormLabel>
      <Select
        {...commonSelectProps}
        value={values.dietaryHabits || ""}
        onChange={(e) => setField("dietaryHabits", e.target.value)}
        placeholder="Select dietary habits"
      >
        {DIETARY_HABITS_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </Select>
    </FormControl>

    <FormControl>
      <FormLabel>{FIELD_LABELS.HOBBIES_INTERESTS}</FormLabel>
      <Input
        {...commonInputProps}
        value={values.hobbies || ""}
        onChange={(e) => setField("hobbies", e.target.value)}
      />
    </FormControl>

    <FormControl>
      <FormLabel>{FIELD_LABELS.OWNS_HOUSE}</FormLabel>
      <Select
        {...commonSelectProps}
        value={values.ownsHouse || ""}
        onChange={(e) => setField("ownsHouse", e.target.value)}
      >
        <option value="">Select</option>
        {OWNS_HOUSE_OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </Select>
    </FormControl>
  </>
);

export default LifestyleEditForm;
